import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";
import { Radio } from "./Radio.js";

interface YesNo extends IAdvancedSearchFieldProps {
  yes: boolean;
}

function YesNoRadio(props: YesNo) {
  const { yes } = props;

  return (
    <Radio
      id={`advanced-search-radio-${props.field.input.name}-${yes ? "yes" : "no"}`}
      label={yes ? "Yes" : "No"}
      checked={props.filterOperation.value === String(yes)}
      defaultChecked={yes}
      onChange={(event: any) =>
        props.onChangeState({ value: event.currentTarget.value === "on" ? String(yes) : String(!yes) })
      }
      onBlur={props.onBlur}
    />
  );
}

/**
 * Boolean input field for advanced search criteria.
 */
export default function AdvancedSearchBoolean(props: IAdvancedSearchFieldProps) {
  return (
    <div className="radio radio-custom">
      <YesNoRadio {...props} yes={true} />
      <YesNoRadio {...props} yes={false} />
    </div>
  );
}
